module.exports = {"id":"193738","name":"Younès Belhanda","rating":"81","photo":"./data/images/photos/2/193738.png","club":{"name":"Galatasaray","logo":"./data/images/clubs/Galatasaray.png"},"positions":["MOC","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YounesBelhanda0.json
// module id = 4428
// module chunks = 0